import { IDislikerDocument } from './IDislikerDocument';
import { ILikeable } from './ILikeable';
import { ILikerDocument } from './ILikerDocument';

export { IDislikerDocument, ILikeable, ILikerDocument };
